import { useRef, useEffect, useState } from 'react';
import { useLocation } from "react-router-dom";
import { useThree } from '@react-three/fiber';
import * as THREE from 'three';
import gsap from 'gsap';
import viewConfig from '/data/viewConfig.json';

export default function Fog() {
    const [screenType, setScreenType] = useState('');
    const location = useLocation();
    const { scene } = useThree();
    const fogRef = useRef();
    
    useEffect(() => {
        const isMobile = window.innerWidth < 768;
        setScreenType(isMobile ? 'mobile' : 'computer');
    }, []);
    
    useEffect(() => {
        const currentPath = location.pathname;
        if (!fogRef.current) {
            fogRef.current = new THREE.Fog(new THREE.Color('#EDE9DF'), 1, 2);
            scene.fog = fogRef.current;
        }
        const currentFogData = viewConfig[screenType]?.[currentPath] || {};
        const newFogNear = currentFogData.near || 1;
        const newFogFar = currentFogData.far || 10;
        const easing = currentFogData.easing || 2; 

        gsap.to(scene.fog, {
            near: newFogNear,
            far: newFogFar,
            duration: easing,
            ease: 'power1.inOut',
        });
    }, [location.pathname, screenType, scene]);

    return null;
}
